import { usePage } from "@inertiajs/vue3";
import type { UserDetails } from "~vue/appTypes";
import { ACCESS } from "~vue/utils/constants";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

export function useProfileSharingCopy() {
    const { t } = useI18n();
    const page = usePage<{ pair_perspective_enabled?: boolean; user_details?: UserDetails | null }>();
    const canComparePerspectives = computed(() => page.props.pair_perspective_enabled === true);
    const sharingDisclosure = computed(() => t("profile.collaboration.sharing.disclosure"));

    // The profile page's access button and DefaultSharingDialog, which tells the user to press it,
    // must show the same label.
    function accessButtonLabel(access: ACCESS): string {
        return {
            [ACCESS.PRIVATE]: t("profile.collaboration.sharing.accessButton.private"),
            [ACCESS.INVITED_ORG_MEMBERS]: t("profile.collaboration.sharing.accessButton.invited"),
            [ACCESS.ORGANIZATION]: t("profile.collaboration.sharing.accessButton.organization"),
        }[access];
    }

    return { canComparePerspectives, sharingDisclosure, accessButtonLabel };
}
